import { Navigate } from 'react-router';
import { BlossomRoutes } from '../../../../RouteConstants';
import Features from '../../../../../Features/feature-flags';
import { IRoutes } from '../../../../../components/3.0/Layouts/TabbedLayout/utils/constants/routes.interface';
import { LoadingIndicator } from '@components/LoadingIndicatorMaterial';
import { RouteErrorPage } from '@components/ErrorBoundary';

export const routes: IRoutes[] = [
  {
    routeItem: {
      path: `${BlossomRoutes.tenantAdmin.user.base}`,
      hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
      async lazy() {
        const Users = (await import('../../../../../Modules/UserManagement/Users/Users')).default;

        return {
          element: <Users />,
          errorElement: <RouteErrorPage />,
        };
      },
    },
    permissionRef: BlossomRoutes.tenantAdmin.user.permissions,
    featureFlag: true,
  },
  {
    routeItem: {
      path: `${BlossomRoutes.tenantAdmin.dataSecurity.base}`,
      children: [
        {
          path: '*',
          hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
          async lazy() {
            const DataSecurity = (
              await import('../../../../../Modules/UserManagement/DataSecurity/DataSecurity')
            ).default;

            return {
              element: <DataSecurity />,
              errorElement: <RouteErrorPage />,
            };
          },

          children: [
            {
              path: '',
              element: <Navigate to={`security-clearance`} />,
            },
            {
              path: 'security-clearance',
              hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
              async lazy() {
                const SecurityClearance = (
                  await import(
                    '../../../../../Modules/UserManagement/DataSecurity/SecurityClearance/SecurityClearance'
                  )
                ).default;

                return {
                  element: <SecurityClearance />,
                  errorElement: <RouteErrorPage />,
                };
              },
            },
            {
              path: 'client-access',
              hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
              async lazy() {
                const ClientAccess = (
                  await import(
                    '../../../../../Modules/UserManagement/DataSecurity/ClientAccess/ClientAccess'
                  )
                ).default;

                return {
                  element: <ClientAccess />,
                  errorElement: <RouteErrorPage />,
                };
              },
            },
          ],
        },
      ],
    },
    permissionRef: BlossomRoutes.tenantAdmin.dataSecurity.permissions,
    featureFlag: (Features as any).clientAccess,
  },

  {
    routeItem: {
      path: `${BlossomRoutes.tenantAdmin.recovery.base}`,
      children: [
        {
          path: '*',
          hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
          async lazy() {
            const Recovery = (
              await import('../../../../../Modules/UserManagement/Recovery/Recovery')
            ).default;

            return {
              element: <Recovery />,
              errorElement: <RouteErrorPage />,
            };
          },

          children: [
            {
              path: '',
              element: <Navigate to={'snapshot'} />,
            },
            {
              path: 'snapshot',
              hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
              async lazy() {
                const Snapshot = (
                  await import('../../../../../Modules/UserManagement/Recovery/Snapshot/Snapshot')
                ).default;

                return {
                  element: <Snapshot />,
                  errorElement: <RouteErrorPage />,
                };
              },
            },
            {
              path: 'import',
              hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
              async lazy() {
                const Import = (
                  await import('../../../../../Modules/UserManagement/Recovery/Import/Import')
                ).default;

                return {
                  element: <Import />,
                  errorElement: <RouteErrorPage />,
                };
              },
            },
            {
              path: 'clean-ingestion',
              hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
              async lazy() {
                const CleanIngestion = (
                  await import(
                    '../../../../../Modules/UserManagement/Recovery/CleanIngestion/CleanIngestion'
                  )
                ).default;

                return {
                  element: <CleanIngestion />,
                  errorElement: <RouteErrorPage />,
                };
              },
            },
          ],
        },
      ],
    },
    permissionRef: BlossomRoutes.tenantAdmin.recovery.permissions,
    featureFlag: true,
  },
  {
    routeItem: {
      path: `${BlossomRoutes.tenantAdmin.security.base}`,
      children: [
        {
          path: '*',
          hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
          async lazy() {
            const Security = (
              await import('../../../../../Modules/UserManagement/Security/Security')
            ).default;

            return {
              element: <Security />,
              errorElement: <RouteErrorPage />,
            };
          },

          children: [
            {
              path: '',
              element: <Navigate to={'ssl-certs'} />,
            },

            {
              path: 'ssl-certs',
              hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
              async lazy() {
                const SSLCerts = (
                  await import(
                    '../../../../../Modules/UserManagement/Security/components/SSLCerts/SSLCerts'
                  )
                ).default;

                return {
                  element: <SSLCerts />,
                  errorElement: <RouteErrorPage />,
                };
              },
            },
          ],
        },
      ],
    },
    permissionRef: BlossomRoutes.tenantAdmin.security.permissions,
    featureFlag: true,
  },
];
